import React from "react";

import {
  IconButton,
  IconButtonProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import ControlTooltip from "@app/analytics/components/ControlTooltip";

import { Row, StackProps } from "@rui/Stack";

export const Container = styled<React.FC<StackProps>>((props) => (
  <Row variant="apart" {...props} />
))(({ theme }) => ({
  scrollMarginTop: "80px",
  borderBottom: `1px solid ${theme.palette.shades.neutral[100]}`,
  width: "100%",
  paddingTop: theme.spacing(3),
}));

export const Title = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryMed" {...props} />
))(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[800],
  padding: theme.spacing(1),
}));

type ControlProps = IconButtonProps & { tooltip: string };

export const Control = styled(({ tooltip, ...props }: ControlProps) => (
  <ControlTooltip title={tooltip}>
    {/* Wrapper so that the tooltip won't yell at us when the button is disabled */}
    <Row sx={{ height: "20px", width: "20px" }}>
      <IconButton {...props} />
    </Row>
  </ControlTooltip>
))(({ theme }) => ({
  borderRadius: "4px",
  height: "20px",
  width: "20px",
  "& svg": {
    color: theme.palette.shades.neutral[500],
    fontSize: "16px",
  },
  "&:hover": {
    backgroundColor: theme.palette.shades.neutral[50],
    "& svg": {
      color: theme.palette.shades.neutral[700],
    },
  },
  "&:disabled": {
    "& svg": {
      color: theme.palette.shades.neutral[300],
    },
  },
}));
